export default __webpack_public_path__ + "static/media/@wizzie08.8d03b785.jpeg";